import Vue from 'vue';
import get from 'lodash/get';

import * as backendConstants from '../constants/backendConstants';
import { MUTATION_REGISTER_SNAPSHOT_LISTENER } from './constants';
import {
  onSnapshot,
  firestoreCollection,
  setMerge,
} from '../firebase/firestore';

const MODULE_PREFIX = 'analysisVotes';

const ACTION_UPDATE_USER_ANALYSIS_VOTE = 'updateUserAnalysisVote';
const ACTION_FETCH_USER_ANALYSIS_VOTES = 'fetchUserAnalysisVotes';

const MUTATION_SET_USER_ANALYSIS_VOTES = 'SET_USER_ANALYSIS_VOTES';

const GETTER_USER_ANALYSIS_VOTES = 'getUserAnalysisVotes';
const GETTER_CURRENT_USER_VOTE = 'getCurrentUserVote';

const initialState = {
  votes: {},
  currentUserVotes: {},
};

const actions = {
  [ACTION_UPDATE_USER_ANALYSIS_VOTE]: async (_, { analysisId, userAnalysisId, elementId, userId, voteType }) => {
    setMerge(
      getUserVotesDocRef(analysisId, userAnalysisId, userId),
      {
        id: userId,
        votes: {
          [elementId]: voteType,
        },
      },
    );
  },
  [ACTION_FETCH_USER_ANALYSIS_VOTES]: async ({ commit, getters }, { analysisId, userAnalysisId }) => {
    console.log('ACTION_FETCH_USER_ANALYSIS_VOTES', analysisId, userAnalysisId);

    if (get(getters[GETTER_USER_ANALYSIS_VOTES]({ analysisId, userAnalysisId }), 'fetchLaunched', false)) {
      console.log(`ACTION_FETCH_USER_ANALYSIS_VOTES canceled for ${analysisId}/${userAnalysisId} since fetchLaunched is true`);
      return;
    }

    commit(MUTATION_SET_USER_ANALYSIS_VOTES, { analysisId, userAnalysisId, votes: { fetchLaunched: true } });
    // Register snapshot listeners for the votes subcol of each user analysis TODO deregister
    const unsubscribeUserAnalyseVotes = onSnapshot(
      getVotesCollectionRef(analysisId, userAnalysisId),
      onUserAnalysisVotesSnapshot.bind(this, { commit, analysisId, userAnalysisId }),
    );

    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener: unsubscribeUserAnalyseVotes, id: `userAnalysisVotes-${userAnalysisId}` },
      { root: true },
    );
  },

};

const getUserVotesDocRef = (analysisId, userAnalysisId, userId) =>
  getVotesCollectionRef(analysisId, userAnalysisId).doc(userId);

const getVotesCollectionRef = (analysisId, userAnalysisId) => firestoreCollection(
  `${backendConstants.FIRESTORE_COLLECTION_ANALYSES}/${analysisId}/`
  + `${backendConstants.FIRESTORE_SUBCOLLECTION_USER_ANALYSES}/${userAnalysisId}/votes`,
);

async function onUserAnalysisVotesSnapshot({ commit, analysisId, userAnalysisId }, snapshots) {
  if (snapshots && snapshots.docs) {
    const votes = snapshots.docs.map(snapshot => snapshot.data());
    commit(MUTATION_SET_USER_ANALYSIS_VOTES, {
      analysisId,
      userAnalysisId,
      votes: {
        fetchLaunched: true,
        votes,
      },
    });
  }
}

const getters = {
  [GETTER_USER_ANALYSIS_VOTES]: (state) => ({ analysisId, userAnalysisId }) =>
    get(state.votes[`${analysisId}/${userAnalysisId}`], 'votes'),
  [GETTER_CURRENT_USER_VOTE]: (state) => ({ analysisId, userAnalysisId }) =>
    state.currentUserVotes[`${analysisId}/${userAnalysisId}`],
};


const mutations = {
  [MUTATION_SET_USER_ANALYSIS_VOTES]: (state, { analysisId, userAnalysisId, votes }) => {
    Vue.set(state.votes, `${analysisId}/${userAnalysisId}`, votes);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  actions: {
    updateUserAnalysisVote: `${MODULE_PREFIX}/${ACTION_UPDATE_USER_ANALYSIS_VOTE}`,
    fetchUserAnalysisVotes: `${MODULE_PREFIX}/${ACTION_FETCH_USER_ANALYSIS_VOTES}`,
  },
  getters: {
    userAnalysisVotes: `${MODULE_PREFIX}/${GETTER_USER_ANALYSIS_VOTES}`,
    currentUserVote: `${MODULE_PREFIX}/${GETTER_CURRENT_USER_VOTE}`,
  },
};
